<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { __ } from 'JIX/gettext.js';

import DsCheckSwitch from 'JIX/components/ds/DsCheckSwitch.vue';
import getToastManager from 'JIX/ui/toasts.js';

const store = useStore();

const adminMode = computed({
    get: () => store.getters.isAdmin,
    set: (value) => {
        store.commit('setAdmin', value);
        store.dispatch('performSearch');
    },
});

const solrDebug = computed(() => store.state.searchResponse.debug?.solr);
const excelEmailSearchClicks = computed(() => store.state.searchResponse.excel_email_search_clicks);

async function sendExcelEmailSearchClicks()  {
    const response = await fetch(excelEmailSearchClicks.value);
    if (response.ok) {
        getToastManager().createToast({
            title: 'Email med klikstatistik sendt',
            message: 'Du vil om kort tid modtage en email med et vedhæftet vedhæftet excelark der indeholder klikstatistik for den valgte søgning.',
            type: 'info'
        }).show();
    } else {
        getToastManager().createToast({
            title: 'Noget gik galt',
            message: 'Vi kunne ikke sende en email med klikstatistik. Tjek din netværksforbindelse og prøv igen.',
            type: 'danger'
        }).show();
    }
};


</script>

<template>
    <div>
        <div class="d-flex gap-3 flex-column">
        <DsCheckSwitch
            v-model="adminMode"
        >
            {{ __('Administratorversion') }}
        </DsCheckSwitch>
            <button
                type="button"
                @click.prevent="sendExcelEmailSearchClicks"
                class="btn btn-secondary w-50"
                v-if="adminMode"
            >
                Klikstatistik som Excelark i e-mail
            </button>
            <details v-if="solrDebug">
                <summary>Query debug</summary>
                <div class="bg-surface-default px-3 border">
                    <strong>querystring:</strong>
                    <div class="mb-3">
                        <code>{{ solrDebug.querystring }}</code>
                    </div>
                    <strong>parsed_query:</strong>
                    <div class="mb-3">
                        <code>{{ solrDebug.parsedquery }}</code>
                    </div>
                    <strong>filters:</strong>
                    <ul>
                        <li
                            v-for="filter, i of solrDebug.filter_queries"
                            :key="i"
                        >
                            <code>{{ filter }}</code>
                        </li>
                    </ul>
                </div>
            </details>
        </div>
    </div>
</template>
